<template>
  <Form :company_id="company_id" :user_id="user_id" />
</template>

<script>
import Form from "../users/Form";
import api from '@/helpers/api';
export default {
  components: { Form },
  data() {
    return {
      company_id: '',
      user_id: this.$route.params.id
    };
  },
  mounted(){
    api.get(`/user/${this.user_id}`).then(response => {
      this.company_id = response.user.company_id;
      console.log(this.company_id)
    });
  }
};
</script>
